import {
  // combineReducers,
  configureStore,
  ReducersMapObject,
} from '@reduxjs/toolkit';
import { gamesReducer } from 'pages/RockPaperScissors/plays/model/slice/gamesSlice';
import { TState } from './types';
import { loginReducer } from 'pages/login/store/store';
import { shopReducer } from 'pages/RockPaperScissors/shops/model/slice/shopSlice';
import { pollsReducer } from 'pages/pollsPage/model/slice/pollSlice';
import { ownRespondentInviteReducer } from 'pages/invitePage/model/slice/ownRespondentInviteSlice';
import { profileReducer } from 'pages/Splittest/profile/model/slice/profileSlice';
import { transactionsReducer } from 'pages/Splittest/balance/model/slice/trnasactionsSlice';
import { appReducer } from './appSlice';
import { webLoginReducer } from 'pages/webLogin/store/store';

export function createReduxStore() {
  const rootReducers: ReducersMapObject<TState> = {
    games: gamesReducer,
    login: loginReducer,
    shop: shopReducer,
    polls: pollsReducer,
    ownRespondentInvite: ownRespondentInviteReducer,
    profile: profileReducer,
    transactions: transactionsReducer,
    appState: appReducer,
    webLogin: webLoginReducer,
  };

  const store = configureStore({
    reducer: rootReducers,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
  });

  return store;
}

// export type ТRootState = ReturnType<typeof rootReducer>;

export type AppDispatch = ReturnType<typeof createReduxStore>['dispatch'];
